import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { FAQS } from "../lib/content";
import { Reveal, Eyebrow, MaskLines } from "./Reveal";

export const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="relative py-24 sm:py-32">
    <div className="mx-auto grid max-w-[1400px] gap-12 px-5 sm:px-8 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <Reveal><Eyebrow>06 — FAQ</Eyebrow></Reveal>
        <h2 className="font-display mt-6 text-3xl font-semibold leading-[1.05] tracking-tight sm:text-5xl">
          <MaskLines inView lines={[<>Perguntas</>, <span className="text-grad">frequentes.</span>]} />
        </h2>
      </div>
      <Reveal delay={0.1} className="lg:col-span-8">
        <Accordion type="single" collapsible className="border-t border-white/10">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`q${i}`} className="border-b border-white/10">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="group py-6 text-left font-display text-lg font-medium text-white hover:no-underline sm:text-xl [&>svg]:h-5 [&>svg]:w-5 [&>svg]:text-[#00C8FF]">
                <span className="flex gap-5"><span className="font-mono-jl pt-1 text-xs text-slate-400">{String(i + 1).padStart(2, "0")}</span>{f.q}</span>
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-content-${i}`} className="pb-6 pl-10 text-base leading-relaxed text-slate-300">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
